import { useEffect, useState } from 'react';
import { santaClient } from './client';

/** The same annual participation total used by the original site. */
export function useAnnualParticipantCount(): number | null {
  const [count, setCount] = useState<number | null>(null);

  useEffect(() => {
    let active = true;
    void santaClient.counter().then((result) => {
      // The endpoint can return a Redis string despite its numeric client type.
      const raw: unknown = result.data;
      const value = typeof raw === 'number' ? raw
        : typeof raw === 'string' && /^\d+$/.test(raw) ? Number(raw) : NaN;
      if (active && result.ok && Number.isSafeInteger(value) && value >= 0) {
        setCount(value);
      }
    }).catch(() => {
      // Omit the statistic when unavailable; never substitute a made-up total.
    });
    return () => { active = false; };
  }, []);

  return count;
}
